import type { StoreApi, OpenArchiveIssueModalProps } from './types.tsx';

export const ArchiveIssueModalActions = {
	openArchiveIssueModal:
		({
			issueKey,
			issueId,
			onIssueArchiveSuccess,
			onCloseIssueViewModal,
			triggerPointKey,
			workType,
			issueHierarchyLevel,
		}: OpenArchiveIssueModalProps) =>
		({ setState }: StoreApi) => {
			setState({
				isArchiveIssueModalOpen: true,
				issueKey,
				issueId,
				onIssueArchiveSuccess,
				onCloseIssueViewModal,
				triggerPointKey,
				workType,
				issueHierarchyLevel,
			});
		},
	closeArchiveIssueModal:
		() =>
		({ setState }: StoreApi) => {
			setState({
				isArchiveIssueModalOpen: false,
				issueKey: null,
				issueId: null,
				onIssueArchiveSuccess: null,
				onCloseIssueViewModal: null,
				triggerPointKey: null,
				workType: null,
			});
		},
};

export type Actions = typeof ArchiveIssueModalActions;
